<div class="my-games-container" *ngIf="isLogged">
    <app-dynamic-category *ngIf="games.length>0" categoryName="{{categoryName}}" [linkUrl]="linkUrl" [games]="games" rowsCount="1">
    </app-dynamic-category>
    <app-dynamic-category *ngIf="isLoading" categoryName="{{categoryName}}" [isLoading]="isLoading" [linkUrl]="linkUrl" [games]="games" rowsCount="1">
    </app-dynamic-category>
</div>
